import React, { useState, useEffect } from "react";
import { Clipboard } from "lucide-react";
import { addHours } from "date-fns";
import { ChargeIdStatusType } from "views/Pix/providers/dto/create-checkout.dto";
import {
  Container,
  QRCodeImage,
  QRCodeSection,
  InfoSection,
  ExpirationSection,
  ExpirationLabel,
  CountdownTimer,
  PixSection,
  PixCodeContainer,
  PixCode,
  CopyButton,
} from "./styles";
import { CountDown } from "../CountDown";
import StatusPix from "./Status";

interface PixPaymentProps {
  status?: ChargeIdStatusType;
  due_date?: string;
  pixCode?: string;
  handleConsultAgain?: () => void;
  onSuccess?: () => void;
  onError?: (message: string) => void;
}

export default function PixPayment({
  status,
  due_date,
  pixCode = "",
  handleConsultAgain,
  onSuccess,
  onError,
}: PixPaymentProps) {
  const [copied, setCopied] = useState(false);

  const handleCopyPixCode = async () => {
    try {
      await navigator.clipboard.writeText(pixCode || "");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  function handleStatusPix(status: ChargeIdStatusType | undefined) {
    switch (status) {
      case ChargeIdStatusType.CHARGE_DONE:
        onSuccess?.();
        break;
      case ChargeIdStatusType.CHARGE_DENIED:
      case ChargeIdStatusType.CHARGE_ERROR:
      case ChargeIdStatusType.CHARGE_REVERSED:
      case ChargeIdStatusType.CHARGE_CANCELED:
        onError?.("Problema ao realizar pagamento!");
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    handleStatusPix(status);
  }, [status]);

  return (
    <Container>
      <QRCodeSection>
        <QRCodeImage size={225} value={pixCode} />
      </QRCodeSection>

      <InfoSection>
        <StatusPix
          status={status || ChargeIdStatusType.WAITING_CHARGE}
          handleConsultAgain={() => handleConsultAgain?.()}
        />

        {status !== ChargeIdStatusType.CHARGE_DONE && (
          <ExpirationSection>
            <ExpirationLabel>Expiração em</ExpirationLabel>
            <CountdownTimer>
              <CountDown
                to={due_date || addHours(new Date(), 1).toISOString()}
              />
            </CountdownTimer>
          </ExpirationSection>
        )}

        <PixSection>
          <ExpirationLabel>Pix copia e cola</ExpirationLabel>
          <PixCodeContainer>
            <PixCode>{pixCode}</PixCode>
            <CopyButton onClick={handleCopyPixCode} title="Copiar código PIX">
              <Clipboard color="#6B7280" />
            </CopyButton>
          </PixCodeContainer>
          {copied && (
            <div style={{ color: "#28a745", fontSize: "0.85rem" }}>
              Código copiado!
            </div>
          )}
        </PixSection>
      </InfoSection>
    </Container>
  );
}
